document.addEventListener("DOMContentLoaded", () => {
    const glossary = document.querySelector(".glossary");
    if (!glossary) return;

    const glossaryItems = document.querySelectorAll(".glossary__item");
    const alphabet = document.querySelectorAll(".glossary__alphabet [data-letter]");
    const lettersInGlossary = [...glossaryItems].map((item) => item.dataset.letter);
    const letterSet = new Set(lettersInGlossary);
    const selectedLettterDOM = document.querySelector(".selected-letter");
    const allItemsButton = document.querySelector(".glossary__all-items");
    const glossaryListLabel = document.querySelector(".glossary__list-label");
    const showMore = document.querySelector(".glossary__show-more");
    const searchBar = document.querySelector(".glossary__search-bar input");

    let selectedLetter = "";
    selectedLettterDOM.textContent = selectedLetter;

    allItemsButton.classList.add("active");
    glossaryListLabel.innerText = "Alle Themen";
    //glossaryItems.forEach((item) => item.classList.remove("hidden"));

    glossaryItems.forEach((item) => {
        if (item.dataset.letter === selectedLetter) {
            item.classList.remove("hidden");
        }
    });

    alphabet.forEach((letter) => {
        if (!letterSet.has(letter.dataset.letter)) {
            letter.disabled = true;
        }

        letter.addEventListener("click", (event) => {
            selectedLetter = event.target.dataset.letter;
            showMore.classList.add("hidden");
            glossaryListLabel.innerText = "Themen zu " + selectedLetter + "'";
            document.querySelectorAll(".glossary__alphabet button").forEach((button) => button.classList.remove("active"));
            event.target.classList.add("active");

            selectedLettterDOM.textContent = selectedLetter;
            glossaryListLabel.classList.remove("hidden");

            glossaryItems.forEach((item) => {
                if (item.dataset.letter === selectedLetter) {
                    item.classList.remove("hidden");
                } else {
                    item.classList.add("hidden");
                }
            });
        });
    });

    // ALL ITEMS BUTTON

    allItemsButton.addEventListener("click", () => {
        document.querySelectorAll(".glossary__alphabet button").forEach((button) => button.classList.remove("active"));
        allItemsButton.classList.add("active");
        showMore.classList.remove("hidden");
        glossaryItems.forEach((item, i) => {
            if (i < 5) {
                item.classList.remove("hidden");
            } else {
                item.classList.add("hidden");
            }
        });
        glossaryListLabel.innerText = "Alle Themen";
    });

    // SEARCH BAR

    searchBar.addEventListener("keyup", () => {
        const searchBarValue = searchBar.value.toUpperCase();
        showMore.classList.add("hidden");
        document.querySelectorAll(".glossary__alphabet button").forEach((button) => button.classList.remove("active"));

        let selectedLetter = "";
        allItemsButton.classList.add("active");
        glossaryListLabel.innerText = "Alle Themen";

        for (i = 0; i < glossaryItems.length; i++) {
            const txtValue = glossaryItems[i].textContent.toUpperCase();

            if (txtValue.indexOf(searchBarValue) > -1) {
                glossaryItems[i].classList.remove("hidden");
            } else {
                glossaryItems[i].classList.add("hidden");
            }
        }

        if (searchBarValue === "") {
            if (selectedLetter) {
                glossaryListLabel.innerText = "Themen zu " + selectedLetter + "'";
            } else {
                glossaryListLabel.innerText = "Alle Themen";
            }

            glossaryItems.forEach((item, i) => {
                if (i < 5) {
                    item.classList.remove("hidden");
                } else {
                    item.classList.add("hidden");
                }
            });
            showMore.classList.remove("hidden");
        }
    });

    // SHOW MORE BUTTON

    showMore.addEventListener("click", () => {
        let i = 0;

        const nextGlossaryItems = [...glossaryItems].filter((item) => {
            if (i < 5 && item.classList.contains("hidden")) {
                i++;
                return item;
            }
        });

        nextGlossaryItems.map((item) => item.classList.remove("hidden"));

        const hasHiddenItems = [...glossaryItems].some((item) => item.classList.contains("hidden"));
        !hasHiddenItems && showMore.classList.add("hidden");
    });
});
